(function(){
  var bar=document.getElementById('tw-sticky-atc');
  if(!bar)return;
  var realBtn=document.querySelector('product-form [name="add"], .product-form__submit, form[action*="/cart/add"] [name="add"]');
  var addBtn=bar.querySelector('[data-tw-sticky-add]');
  if(!realBtn){bar.remove();return;}
  var strings=window.variantStrings||{};
  if(addBtn){addBtn.addEventListener('click',function(){realBtn.click();});}
  function sync(){ if(!addBtn)return; if(realBtn.hasAttribute('disabled')){addBtn.setAttribute('disabled','');var t=(realBtn.textContent||'').trim();addBtn.textContent=t?t.slice(0,22):(strings.soldOut||'Sold out');}else{addBtn.removeAttribute('disabled');addBtn.textContent=strings.addToCart||'Add to cart';} }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){var hidden=e.isIntersecting;bar.classList.toggle('is-visible',!hidden);bar.setAttribute('aria-hidden',hidden?'true':'false');bar.toggleAttribute('inert',hidden);});},{rootMargin:'0px 0px -16px 0px',threshold:0});
    io.observe(realBtn);
  }
  try{new MutationObserver(sync).observe(realBtn,{attributes:true,childList:true,subtree:true});}catch(e){}
  sync();
})();
